import { Button, Card, Empty, message, Popconfirm, Select, Space } from "antd";
import React, { useState, useRef, useEffect } from "react";
import { AWS_API, ASSET_URL } from "../../../../config";
import { FaImage, FaPlus } from "react-icons/fa";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { FaArrowsAltV, FaEye, FaEyeSlash } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
const LayersDesign = ({
  backgrounds,
  onAddLayer,
  onRemoveLayer,
  onChangeVisible,
  onChangePosition,
  onSelectLayer,
  selectLayer,
  layerID,
  widthCanvas,
  backgroundDesign
}) => {
  const inputFile = useRef();
  const [dragItem, setDragItem] = useState(null);
  const [dragOverItem, setDragOverItem] = useState(null);
  const [loading, setLoading] = useState(false);

  const getSignedUrl = async (mime) => {
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };
    var signedUrl = null;
    await fetch(`${AWS_API}/signedUrl?type=${mime}`, requestOptions)
      .then((response) => response.json())
      .then((res) => (signedUrl = res))
      .catch((err) => console.error(err));
    return signedUrl;
  };

  const upload = async (base64) => {
    var file = await fetch(base64)
      .then((res) => res.arrayBuffer())
      .then((buf) => new File([buf], "tmp.png", { type: "image/png" }));
    var signedUrl = await getSignedUrl(file.type);
    const upFile = await axios
      .put(signedUrl.url, file, {
        headers: {
          "Content-Type": file.type,
        },
      })
      .catch((err) => console.error(err));

    if (upFile.status == 200) {
      return {
        status: true,
        key: signedUrl.key,
      };
    } else {
      return {
        status: false,
      };
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  function getImageSize(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = function () {
        reject("Error loading image");
      };
      img.src = url;
    });
  }

  const handleAddLayer = () => {
    inputFile.current.click();
  };
  const handleChangeFileAddlayer = async (e) => {
    const files = e.target.files;
    if (!files[0]) return;

    setLoading(true);
    const file = files[0];
    e.target.value = null;
    const base64 = await toBase64(file);
    const upFile = await upload(base64);
    if (upFile.status) {
      const url = ASSET_URL + upFile.key;
      const getSize = await getImageSize(url);
      const scaleWidth = (widthCanvas * 0.8) / getSize.width;
      const width = getSize.width * scaleWidth;
      const height = getSize.height * scaleWidth;
      const itemLayer = {
        id: uuidv4(),
        width,
        height,
        url,
        x: (widthCanvas - width) / 2,
        y: (widthCanvas - width) / 2,
        name: file.name,
        visible: true,
        typeLayer: "layer",
        shadowEnabled: true,
        shadowColor: "#000000",
        shadowOpacity: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowBlur: 20,
        opacity: 1,
        stroke: "#000000",
        strokeWidth: 0,
      };
      onAddLayer(itemLayer);
    }
    setLoading(false);
  };

  const confirmDeleteLayer = (id) => {
    onRemoveLayer(id);
  };

  const onDragStart = (_, index) => {
    setDragItem(index);
  };

  const onDragOver = (index) => {
    setDragOverItem(index);
  };

  const handleChangeVisibility = (id) => {
    onChangeVisible(id);
  };

  const changePosition = (arr, index, newPosition) => {
    if (
      index >= arr.length ||
      index < 0 ||
      newPosition >= arr.length ||
      newPosition < 0
    ) {
      return arr;
    }
    let newArr = [...arr];
    let elementToMove = newArr.splice(index, 1)[0];
    newArr.splice(newPosition, 0, elementToMove);
    return newArr;
  };

  const onDrop = () => {
    const layers = backgroundDesign.layers || [];
    const layerNewPosition = changePosition(layers, dragItem, dragOverItem);
    onChangePosition(layerNewPosition);
    setDragItem(null);
    setDragOverItem(null);
  };

  const shortenString = (str, maxLength) => {
    if (str.length <= maxLength) {
      return str;
    }

    const cutLength = (maxLength - 6) / 2; // Để chừa dấu "..." và phần đầu/cuối chuỗi
    const firstPart = str.substr(0, cutLength);
    const lastPart = str.substr(str.length - cutLength);

    return `${firstPart}...${lastPart}`;
  };
  return (
    <>
      <input
        ref={inputFile}
        style={{
          display: "none",
        }}
        type="file"
        accept=".png, .jpg, .jpeg"
        onChange={handleChangeFileAddlayer}
      />
      <Card
        extra={
          <Button
            className="btn-add-layer"
            loading={loading}
            disabled={loading}
            onClick={handleAddLayer}
            icon={<FaPlus />}
            type="text"
          >
            <span
              style={{
                marginLeft: 5,
              }}
            >
              Add Layer
            </span>
          </Button>
        }
        title="Layers"
        style={{ width: "100%", marginBottom: 5 }}
      >
        {backgroundDesign.layers &&
        backgroundDesign.layers.length > 0 ? (
          <ul className="group-list-layers">
            {(backgroundDesign.layers || []).map((i, index) => {
              return (
                <li
                  style={{
                    position: "relative",
                  }}
                  key={index}
                >
                  <div
                    className="group-list-layers__item"
                    draggable
                    onDragStart={(e) => onDragStart(e, index)}
                    onDragOver={() => onDragOver(index)}
                    onDrop={onDrop}
                    onDragEnd={onDrop}
                  >
                    <div
                      className={
                        dragOverItem == index ? `drag-box active` : "drag-box"
                      }
                    ></div>
                    <button className="group-list-layers__item__btn_move">
                      <FaArrowsAltV
                        style={{
                          pointerEvents: "none",
                        }}
                      />
                    </button>
                    <div
                      onClick={() => {
                        onSelectLayer(i.id);
                      }}
                      style={{
                        color: selectLayer == i.id ? "#ff9100" : "#000000",
                      }}
                      className="group-list-layers__item__name"
                    >
                      <FaImage />{" "}
                      <span
                        style={{
                          marginLeft: 5,
                        }}
                      >
                        {shortenString(i?.name || "", 25)}
                      </span>
                    </div>
                    <div className="group-list-layers__item__action">
                      {i?.typeLayer != "image-default" && (
                        <>
                          <button
                            onClick={() => handleChangeVisibility(i.id)}
                            className="group-list-layers__item__action_visibility"
                          >
                            {i.visible ? <FaEye /> : <FaEyeSlash />}
                          </button>
                          <Popconfirm
                            placement="topRight"
                            title="Are you sure you want to delete?"
                            onConfirm={() => confirmDeleteLayer(i.id)}
                            okText="Yes"
                            cancelText="No"
                          >
                            <button className="group-list-layers__item__action_delete">
                              <MdDelete />
                            </button>
                          </Popconfirm>
                        </>
                      )}
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </Card>
    </>
  );
};

export default LayersDesign;
